'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var paths = require('../paths.js');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const AgentNavigatorContext = /*#__PURE__*/React__default["default"].createContext(null);
const useAgentNavigator = () => {
  const context = React.useContext(AgentNavigatorContext);
  if (!context) {
    throw new Error('No context provided for AgentNavigator provider');
  }
  return context;
};
const AgentNavigatorProvider = _ref => {
  let {
    children
  } = _ref;
  const navigate = reactRouterDom.useNavigate();
  const navigateToOrderLookup = options => {
    navigate(paths.ORDER_LOOKUP, options);
  };
  const navigateToOrderOverview = options => {
    navigate(paths.ORDER_OVERVIEW, options);
  };
  const navigateToClaimDetails = (id, options) => {
    navigate(paths.CLAIM_DETAILS.replace(':id', id), options);
  };
  return /*#__PURE__*/React__default["default"].createElement(AgentNavigatorContext.Provider, {
    value: {
      navigateToOrderLookup,
      navigateToOrderOverview,
      navigateToClaimDetails
    }
  }, children);
};

exports.AgentNavigatorContext = AgentNavigatorContext;
exports.AgentNavigatorProvider = AgentNavigatorProvider;
exports.useAgentNavigator = useAgentNavigator;
